import { motion } from 'framer-motion'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import auth from '../../../api/auth'
import { IBusinessInfo, ISchemaAdminInfo, ISchemaBusinessSubAndPayment } from '../../../shared/types'
import { selectAdminInfo, selectBusinessInfo } from '../../../store/features/registration'
import { translateAuthErrors } from '../../../utils/errorTranslator'
import CreditCardInput from '../../organisms/CreditCardInput'
import RadioGroup from '../../organisms/RadioGroup'
import ValidatedForm from '../../organisms/ValidatedForm'
import { ValidatedPrimaryButton } from '../../organisms/ValidationButton'


interface IFormDataSubAndPayment{
    subscription_plan: "basic" | "advanced"
    card_number: string
    card_cvc: string
    card_expiry_date: string
}

const initialValues= {
    subscription_plan: "basic",
    card_number: "",
    card_cvc: "",
    card_expiry_date: ""
}

const validationSchema = Yup.object().shape({
    subscription_plan: Yup.string().required().oneOf(["basic", "essentials"]).label("subscription_plan"),
})

export default function PaymentInfo() {

    const [isLoading, setIsLoading] = useState(false)
    const adminData= useSelector(selectAdminInfo)
    const businessInfo = useSelector(selectBusinessInfo)


    const submit = async(data:IFormDataSubAndPayment)=>{

         const sub_and_payment:ISchemaBusinessSubAndPayment={
            package_type: data.subscription_plan,
            payment: {
                card_cvc: data.card_cvc,
                card_expiry: data.card_expiry_date,
                card_number: data.card_number
            },
            subscription: data.subscription_plan
         }

         const businessdata: IBusinessInfo= {
            ...businessInfo as IBusinessInfo,
            sub_and_payment
         }

        try {
            setIsLoading(true)
            await auth.register(businessdata, adminData as ISchemaAdminInfo)
            setIsLoading(false)
            
        } catch (error) {
            setIsLoading(false)
            toast(translateAuthErrors(error),{
                position: "top-center",
                autoClose: 5000,
                className:"text-center",
                type: "warning"
            })
            console.log(error);
        }
        
    }

    return (
        <motion.div
            className="w-full h-92.5"
            exit={{
                x: "-200px",
                opacity: 0
            }}
            initial={{
                opacity: 0,
                x: "100px"
            }}
            animate={{
                opacity: 1,
                x: 0
            }}
        >
            
            <div
                className="absolute top-1/2 left-1/2 translate-x-neg-1/2 translate-y-neg-1/2 bg-white py-8 px-12 shadow-2xl rounded"
            >
                <form>
                    <ValidatedForm
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={submit}
                    >
                        <header className='leading-7 text-center'>
                            <h2 className='font-semibold text-2xl text-primary'>Subscription & Payment</h2>
                            <span className="text-graphite" >Please note, subscription takes effect after trial ends.</span>
                        </header>

                        <div
                            className="mt-12 w-full"
                        >
                            <CreditCardInput 
                                name="name"
                                text="Card details"
                                placeholder="business name"
                            />
                        </div>

                        <div
                            className="mb-12 mt-6 w-full"
                        >

                            <RadioGroup
                                name="subscription_plan"
                                labels={[
                                    {
                                        value: "basic",
                                        text:
                                        <span>
                                            Basic Plan &nbsp;
                                            <span className='text-light_col' >
                                                GH₵ 149.99/month
                                            </span> 
                                        </span>
                                    },
                                    {
                                        value: "essentials",
                                        text: 
                                        <span>
                                            Essentials Plan &nbsp;
                                            <span className='text-light_col' >
                                                GH₵ 299.99/month
                                            </span> 
                                        </span>
                                    },
                                    
                                ]}
                            />

                            
                        </div>

                        <ValidatedPrimaryButton
                            loading={isLoading}
                        >
                            Proceed
                        </ValidatedPrimaryButton>

                        <div style={{margin: "1rem 0"}} className="link">
                            <span className="subtle">Please read more about our subscription plans <Link to="/">here.</Link> </span>
                        </div>

                    </ValidatedForm>
                </form>

            </div>

        </motion.div>
    )
}